import Box from '@mui/material/Box';

interface Props {
  readonly messages: readonly string[];
}

// A single message reads as a sentence, several ones as a list, one per line.
export const MessageList = ({ messages }: Readonly<Props>) => {
  const distinctMessages = [...new Set(messages)];

  return distinctMessages.length === 1 ? (
    distinctMessages[0]
  ) : (
    <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
      {distinctMessages.map((message) => (
        <li key={message}>{message}</li>
      ))}
    </Box>
  );
};
